import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ColorPickerModule } from 'primeng/colorpicker';
// :host ::ng-deep .p-colorpicker-preview {
//     background: white linear-gradient(to top left,
//             rgba(0, 0, 0, 0) 0%,
//             rgba(0, 0, 0, 0) calc(50% - 2px),
//             rgba(255, 0, 0, 1) 50%,
//             rgba(0, 0, 0, 0) calc(50% + 2px),
//             rgba(0, 0, 0, 0) 100%) !important;
// }

@Component({
  selector: 'app-formly-color-picker',
  templateUrl: './formly-color-picker.component.html',
  styleUrls: ['./formly-color-picker.component.scss'],
  standalone: true,
  imports: [
    ColorPickerModule,
    FormlyModule,
    ReactiveFormsModule,
    CommonModule,
  ]
})
export class FormlyColorPickerComponent extends FieldType implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  selectedColor: string = undefined;

  colorPickerStyle: any = {
    width: '100%',
    // background: `linear-gradient(to top left,
    //   rgba(0, 0, 0, 0) 0%,
    //   rgba(0, 0, 0, 0) calc(50% - 2px),
    //   ${this.selectedColor} 50%,
    //   rgba(0, 0, 0, 0) calc(50% + 2px),
    //   rgba(0, 0, 0, 0) 100%)`
  };


  constructor(
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.syncSelectedColor(this.formControl.value);
    // valueChanges must be torn down; re-opening color fields stacked listeners otherwise.
    this.formControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.syncSelectedColor(value);
      });
  }

  ngAfterViewInit() {
    this.syncSelectedColor(this.formControl.value);
  }

  private syncSelectedColor(value: string | null | undefined): void {
    this.selectedColor = value || undefined;
    this.cdr.markForCheck();
  }
}
